import { format } from "date-fns";

export const parseDate = (
	dt = Date.now(),
	joinChar = "-",
	withTime = false
) => {
	const dateToParse = new Date(dt);
	let parser = ["yyyy", "MM", "dd"].join(joinChar);

	if (withTime) parser = [parser, "hhmm"].join(joinChar);

	const formatted = format(dateToParse, parser);

	return formatted;
};

export const dateToday = () => {
	const dtFormatted = new Date(Date.now());
	const dtYear = dtFormatted.getFullYear();
	const dtMonth = dtFormatted.getMonth();
	const dtDay = dtFormatted.getDate();

	return `${dtYear}-${dtMonth}-${dtDay}`;
};
